import { ChatEvaluationTestSetList } from '@/Workspaces/ChatEvaluationTestSet/ChatEvaluationTestSetList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/chatEvaluationTestSet/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatEvaluationTestSetList />
}
